import {
  CORE_LOAD_DISPLAY_REQUEST,
  CORE_LOAD_DISPLAY_SUCCESS,
} from '../../types'

const initialState = []
export default {

  allDisplay: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_DISPLAY_REQUEST:
        return []
      case CORE_LOAD_DISPLAY_SUCCESS:
        return action.payload

      default:
        return state
    }
  }
  ,
  displayInfo: (state = initialState, action) => {
    switch (action.type) {
      // case CORE_GET_IOT_INFO_REQUEST:
      //   return {}

      // case CORE_GET_IOT_INFO_SUCCESS:
      //   return action.payload

      default:
        return state
    }
  }

}


// WEBPACK FOOTER //
// ./src/features/display/reducer.js